import { createElement } from 'react'
import { IRatingDetailsTableProps, IViewProps } from './types'
import RatingDetailsTableView from './view'
import { ReactComponent as StarIcon } from 'assets/images/rating-star.svg'
import { formatDate } from 'shared/util/date'

function RatingDetailsTable({
	ratingDetailsData,
	loadingData,
	handleSetRatingDetailsSearch,
	ratingDetailsSearchString,
	ratingDetailsNavProps,
}: IRatingDetailsTableProps) {
	const ratingDetailsColumns = [
		{
			Header: 'Nome do Atendente',
			accessor: 'attendantName',
			disableSortBy: true,
		},
		{
			Header: 'Nome do Avaliador',
			accessor: 'customerName',
			disableSortBy: true,
		},
		{
			Header: 'Data da Avaliação ',
			accessor: 'ratingDate',
			disableSortBy: true,
		},
		{ Header: 'Nota', accessor: 'rating', disableSortBy: true },
		{ Header: 'Comentário', accessor: 'comment', disableSortBy: true },
	]

	const ratingDetailsRows = ratingDetailsData?.docs.map((rating) => {
		let starIcons = []
		for (let i = 0; i < rating.rating; i++) {
			starIcons.push(createElement(StarIcon))
		}

		return {
			attendantName: rating.attendantName,
			customerName: rating.customerName,
			ratingDate: formatDate(new Date(rating.ratingDate)),
			rating: starIcons,
			comment: rating.message,
		}
	})

	const props: IViewProps = {
		ratingDetailsColumns,
		ratingDetailsRows,
		loadingData,
		ratingDetailsSearchString,
		handleSetRatingDetailsSearch,
		ratingDetailsNavProps,
	}

	return createElement(RatingDetailsTableView, props)
}

export default RatingDetailsTable
